import { useQuery } from '@apollo/client'
import { WizardStep } from '@factorialco/deprecated-design-system'
import { AvailableModules } from 'generated/featureDefinitions'
import { CheckAvailabilityDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { isModuleAvailabilityEnabled } from 'modules/core/lib/isModuleAvailabilityEnabled'

import { A3InnuvaWizardData } from 'modules/payroll_integrations_a3innuva/lib/types'

import { absencesStep } from './AbsencesStep'
import { compensationStep } from './CompensationStep'
import { loginStep } from './LoginStep'
import { rolesStep } from './RolesStep'
import { workplaceStep } from './WorkplaceStep'
import { agreementStep } from './agreementStep'
import { companyStep } from './companyStep'
import { costCenterStep } from './costCenterStep'
import { educationLevelStep } from './educationLevelStep'

export const useA3InnuvaSteps = () => {
  const session = useCurrentSession()
  const { data: featuresData } = useQuery(CheckAvailabilityDocument, {
    variables: { companyId: session.company.id },
  })

  const moduleAvailabilities = featuresData?.companies?.moduleAvailabilitiesConnection?.nodes || []

  const compensationsEnabled = isModuleAvailabilityEnabled(
    moduleAvailabilities,
    AvailableModules.compensations
  )

  let steps: (() => WizardStep<A3InnuvaWizardData>)[] = []
  if (compensationsEnabled) {
    steps = [
      loginStep,
      companyStep,
      workplaceStep,
      rolesStep,
      compensationStep,
      absencesStep,
      costCenterStep,
      educationLevelStep,
      agreementStep,
    ]
  } else {
    steps = [
      loginStep,
      companyStep,
      workplaceStep,
      rolesStep,
      absencesStep,
      costCenterStep,
      educationLevelStep,
      agreementStep,
    ]
  }

  return steps
}
